import { Badge, Chip, Grid } from "@mui/material";
import MxDetailSubTitle from "@rf-l1/page/details/MxDetailSubTitle";
import { usePropertyDetailPage } from "../../context/PropertyDetailPageContext";

const MainDetailImprovementsAmenities = () => {
  const { improvementType } = usePropertyDetailPage();

  if (!improvementType || improvementType?.length === 0) {
    return null;
  }

  return (
    <Grid container gap={2}>
      <Grid item xs={12}>
        <MxDetailSubTitle label="Mejoras y Amenidades" />
      </Grid>
      {improvementType && (
        <Grid container item xs={12} spacing={1} rowSpacing={2}>
          {improvementType.map((improvement, index) => (
            <Grid item xs="auto" key={index}>
              <Chip variant="filled" size="small" label={improvement}></Chip>
            </Grid>
          ))}
        </Grid>
      )}
    </Grid>
  );
};

export default MainDetailImprovementsAmenities;
